export const NEW_ON_EDEL = "NEW_ON_EDEL";
export const NEW_ON_EDEL_ERROR = "NEW_ON_EDEL_ERROR";
export const NEW_ON_EDEL_HIDE_ERROR = "NEW_ON_EDEL_HIDE_ERROR";
export const NEW_ON_EDEL_START_LOADER = "NEW_ON_EDEL_START_LOADER";
export const NEW_ON_EDEL_STOP_LOADER = "NEW_ON_EDEL_STOP_LOADER";
